import { css, Theme } from '@emotion/react';

/** Apply a border radius to an element. */
export const roundedCorners = () => ({ layout }: Theme) => css({ borderRadius: layout.borderRadius });

/** Apply a circular border radius to an element. */
export const circular = () => css({ borderRadius: '50%' });
